import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const isInlineFiltersRedesignedSlice = createSlice({
  name: 'isInlineFiltersRedesigned',
  initialState: false,
  reducers: {
    setIsInlineFiltersRedesigned: (_, action: PayloadAction<boolean>) => action.payload,
  },
});

export const {
  reducer: isInlineFiltersRedesignedReducer,
  name: isInlineFiltersRedesignedReducerName,
  actions: { setIsInlineFiltersRedesigned },
} = isInlineFiltersRedesignedSlice;
